export default {"id":"icon-warning"}